module.exports = __webpack_public_path__ + "static/img/icon_my_st_info.8bab700.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_my_st_info.svg
// module id = X4BR
// module chunks = 10